(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .controller('SettoreDialogController', SettoreDialogController);

    SettoreDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Settore'];

    function SettoreDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Settore) {
        var vm = this;

        vm.settore = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.settore.id !== null) {
                Settore.update(vm.settore, onSaveSuccess, onSaveError);
            } else {
                Settore.save(vm.settore, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('gestioneAttiApp:settoreUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
